(function () {
  const loaded = new Map();

  function loadScript(src) {
    if (loaded.has(src)) return loaded.get(src);
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = resolve;
      script.onerror = () => reject(new Error(`Failed to load ${src}`));
      document.head.appendChild(script);
    });
    loaded.set(src, promise);
    return promise;
  }

  window.ensurePdfDependencies = function ensurePdfDependencies() {
    return loadScript('assets/vendor/jspdf.umd.min.js')
      .then(() => loadScript('assets/vendor/jspdf.plugin.autotable.min.js'));
  };
})();
